import { useThemeStore } from "../../stores";
import { Row, ScrollRow } from "../containers";
import { JustifyContent } from "../containers/types";
import { Text } from "../typography";
import { OptionsProps } from "./types";

const Options = <T,>({
  options,
  selectedOption,
  setSelectedOption,
  props,
  className = "",
  style = {},
  itemStyle = {},
}: OptionsProps<T>) => {
  const theme = useThemeStore((state) => state.theme);
  return (
    <ScrollRow
      style={{ width: "100%", ...style }}
      gap={20}
      className={className}
      props={props}
      height={50}
    >
      {options.map((opt) => (
        <Row
          justifyContent={JustifyContent.Center}
          key={opt.title}
          style={{
            width: 110,
            minWidth: 110,
            minHeight: 32,
            borderRadius: 15,
            border: `1px solid ${
              selectedOption.title === opt.title ? theme.primary : theme.icon
            }`,
            cursor: "pointer",
            ...itemStyle,
          }}
          props={{ onClick: () => setSelectedOption(opt) }}
          className="transition"
        >
          <Text size={14} color={theme.textOnBg}>
            {opt.title}
          </Text>
        </Row>
      ))}
    </ScrollRow>
  );
};
export default Options;
